module.exports = __webpack_public_path__ + "static/media/ducha.ba75bded.svg";